import { render, staticRenderFns } from "./CroOrCdmoDialog.vue?vue&type=template&id=5600d5a0&scoped=true"
import script from "./CroOrCdmoDialog.vue?vue&type=script&lang=js"
export * from "./CroOrCdmoDialog.vue?vue&type=script&lang=js"
import style0 from "./CroOrCdmoDialog.vue?vue&type=style&index=0&id=5600d5a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5600d5a0",
  null
  
)

export default component.exports